import {request} from "../base/HTTP";
import HttpMethod from "../constants/HttpMethod";

export async function getCountry() {
    return await request('/api/country', [], HttpMethod.GET);
}